import { useState, useEffect } from "react";
import api from "../lib/api";
import CrudPage from "../components/CrudPage";

export default function SubCategories() {
  const [categories, setCategories] = useState(null);

  useEffect(() => {
    api.get("/categories", { params: { limit: 200 } }).then((r) => setCategories(r.data.items));
  }, []);

  if (!categories) return null;
  const options = categories.map((c) => ({ value: c.id, label: c.name }));

  return (
    <CrudPage
      title="Alt Kategoriler"
      subtitle="Ana kategorilere bağlı alt kategoriler"
      module="subcategories"
      endpoint="/subcategories"
      addLabel="Yeni Alt Kategori"
      filters={[{ name: "category_id", label: "Ana Kategori", options }]}
      columns={[
        { key: "name", label: "Alt Kategori", render: (r) => <span className="font-medium">{r.name}</span> },
        { key: "category_name", label: "Ana Kategori" },
        { key: "description", label: "Açıklama" },
      ]}
      fields={[
        { name: "name", label: "Alt Kategori Adı", required: true },
        { name: "category_id", label: "Ana Kategori", type: "select", options, required: true },
        { name: "description", label: "Açıklama", type: "textarea" },
      ]}
      transformSubmit={(p) => ({ ...p, category_name: categories.find((c) => c.id === p.category_id)?.name || "" })}
    />
  );
}
